const VALUE_KEYS = ['identifier', 'id', 'value', 'code', 'key'];

const normalizeAudienceValues = (value: unknown): string[] => {
	if (value == null) {
		return [];
	}

	if (Array.isArray(value)) {
		return value.flatMap(normalizeAudienceValues);
	}

	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
		return String(value)
			.split(/[,\s;|]+/)
			.map((entry) => entry.trim().toLowerCase())
			.filter(Boolean);
	}

	if (typeof value === 'object') {
		const record = value as Record<string, unknown>;
		return VALUE_KEYS.flatMap((key) => normalizeAudienceValues(record[key]));
	}

	return [];
};

const collectPackageTargetAudienceValues = (source: unknown): string[] => {
	if (!source || typeof source !== 'object') {
		return [];
	}

	const record = source as Record<string, unknown>;
	return normalizeAudienceValues(record.packageTargetAudience);
};

export const hasPackageTargetAudienceIdentifier = (source: unknown, identifier: string): boolean => {
	const normalizedIdentifier = String(identifier ?? '').trim().toLowerCase();
	if (!normalizedIdentifier) {
		return false;
	}

	return collectPackageTargetAudienceValues(source).includes(normalizedIdentifier);
};
